/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ClientsControllerFindOneQueryResponse, ClientsControllerFindOnePathParams, ClientsControllerFindOneQueryParams, ClientsControllerFindOne400, ClientsControllerFindOne401, ClientsControllerFindOne403, ClientsControllerFindOne404 } from "../../models/clientsController/ClientsControllerFindOne";

function getClientsControllerFindOneUrl(id: ClientsControllerFindOnePathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/clients/${id}` as const }  
  return res
}

/**
 * @summary Get a client by ID
 * {@link /api/v1/clients/:id}
 */
export async function clientsControllerFindOne(id: ClientsControllerFindOnePathParams["id"], params?: ClientsControllerFindOneQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<ClientsControllerFindOneQueryResponse, ResponseErrorConfig<ClientsControllerFindOne400 | ClientsControllerFindOne401 | ClientsControllerFindOne403 | ClientsControllerFindOne404>, unknown>({ method : "GET", url : getClientsControllerFindOneUrl(id).url.toString(), params, ... requestConfig })  
  return res.data
}